import { render, staticRenderFns } from "./CarouselFramed.vue?vue&type=template&id=b261f2ec&"
import script from "./CarouselFramed.vue?vue&type=script&lang=js&"
export * from "./CarouselFramed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports